
/**
 * =================================================================
 * ARQUIVO: stripeEnvironment.ts
 * =================================================================
 *
 * DESCRIÇÃO:
 * Utilitário para gerenciar Price IDs do Stripe baseado no ambiente.
 * Permite alternar entre ambiente de teste e produção de forma consistente
 * com as Edge Functions.
 * 
 * FUNCIONAMENTO:
 * - Detecta ambiente através de variáveis ou configuração
 * - Mapeia Price IDs corretos para cada ambiente
 * - Sincroniza com a lógica das Edge Functions
 */

export type EnvironmentType = 'test' | 'production';

// Função para detectar o ambiente atual
// Agora configurado para produção por padrão
export const getCurrentEnvironment = (): EnvironmentType => {
  // Verifica se há uma configuração específica do ambiente
  return (window as any).__STRIPE_ENVIRONMENT__ || 'production';
};

// Mapeamento de Price IDs por ambiente - NOVOS PLANOS REESTRUTURADOS
const PRICE_IDS_MAP = {
  test: {
    basic: 'price_1ReLiFQAOfvkgjNZQkB2StTz',
    pro: 'price_1ReJriGPYAaRS7MgZVpjvFbT', 
    premium: 'price_1RcAXAQAOfvkgjNZRJA1kxug'
  },
  production: {
    // Novos Price IDs para estrutura de planos reestruturada
    basic: 'price_1SADb7GPYAaRS7MgK6PgPMBr',    // R$ 67
    pro: 'price_1ReJriGPYAaRS7MgZVpjvFbT',      // R$ 147
    premium: 'price_1SADaJGPYAaRS7MgwDDtBzDJ'   // R$ 247
  }
};

// Função para obter Price IDs baseado no ambiente
export const getPriceIds = (environment?: EnvironmentType) => {
  const env = environment || getCurrentEnvironment();
  return PRICE_IDS_MAP[env];
};

// Função para obter um Price ID específico
export const getPriceId = (plan: 'basic' | 'pro' | 'premium', environment?: EnvironmentType): string => {
  const priceIds = getPriceIds(environment);
  return priceIds[plan];
};

// Função para verificar se está em ambiente de teste
export const isTestEnvironment = (): boolean => {
  return getCurrentEnvironment() === 'test';
};

// Função para verificar se está em ambiente de produção
export const isProductionEnvironment = (): boolean => {
  return getCurrentEnvironment() === 'production';
};
